const { createContext, useContext } = require('react');

const ShippingDataContext = createContext({ data: {} });

const useShippingData = () => useContext(ShippingDataContext);

module.exports = {
  useShippingData,
  ShippingDataContext,
};
